/**
 * Shared ABC multi-tune parsing and bulk-import row building (Tunes + AdminAssets).
 */

export function parseMultipleTunes(content) {
  const raw = typeof content === 'string' ? content : '';
  const normalized = raw.replace(/^\uFEFF/, '');
  const lines = normalized.split(/\r?\n/);
  const tunes = [];
  let currentTune = null;
  let header = '';
  let inHeader = true;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    if (trimmed.match(/^X:\s*\d+/i)) {
      if (currentTune) {
        currentTune.fullContent = header + '\n' + currentTune.content;
        tunes.push(currentTune);
      }
      inHeader = false;
      currentTune = {
        content: line + '\n',
        fields: {},
        startLine: i
      };
    } else if (currentTune) {
      currentTune.content += line + '\n';
      if (trimmed && !trimmed.startsWith('%')) {
        const match = trimmed.match(/^([A-Za-z]):(.*)$/);
        if (match) {
          const field = match[1].toUpperCase();
          const value = match[2].trim();
          if (!currentTune.fields[field]) {
            currentTune.fields[field] = value;
          }
        }
      }
    } else if (inHeader) {
      header += line + '\n';
    }
  }

  if (currentTune) {
    currentTune.fullContent = header + '\n' + currentTune.content;
    tunes.push(currentTune);
  }

  return { tunes, header };
}

export function mapTunesToBulkImportEntries(tunes) {
  return tunes.map((tune, index) => {
    const fields = tune.fields;

    const composer = fields.C || '';
    const arranger = fields.Z ? fields.Z.replace(/https?:\/\/[^\s,]+/gi, '').trim() : '';
    const composerArranger = [composer, arranger].filter(Boolean).join(', ');

    const originRegion = [fields.O, fields.A].filter(Boolean).join(', ');
    const sourceAlbum = [fields.D, fields.B].filter(Boolean).join(', ');

    const abcTags = [
      'ABC',
      fields.R,
      fields.K && `key ${fields.K}`,
      composerArranger,
      originRegion,
      sourceAlbum
    ].filter(Boolean).join(', ');

    const descriptionParts = [];
    if (fields.T) descriptionParts.push(`Title: ${fields.T}`);
    if (fields.R) descriptionParts.push(`Type: ${fields.R}`);
    if (fields.K) descriptionParts.push(`Key: ${fields.K}`);
    if (composerArranger) descriptionParts.push(`Composer/Arranger: ${composerArranger}`);
    if (originRegion) descriptionParts.push(`Origin: ${originRegion}`);
    if (sourceAlbum) descriptionParts.push(`Source: ${sourceAlbum}`);

    const description = descriptionParts.join('\n');

    const abcMetadata = {
      rhythm_style: fields.R || '',
      key: fields.K || '',
      composer_arranger: composerArranger || '',
      origin_region: originRegion || '',
      source_album: sourceAlbum || '',
      tune_title: fields.T || ''
    };

    const descriptionWithMetadata = description
      ? `${description}\n\n[ABC_METADATA]${JSON.stringify(abcMetadata)}[/ABC_METADATA]`
      : `[ABC_METADATA]${JSON.stringify(abcMetadata)}[/ABC_METADATA]`;

    const baseTitle = fields.T || `tune_${index + 1}`;
    const sanitizedTitle = baseTitle.replace(/[^a-zA-Z0-9]/g, '_');
    const uniqueFilename = `${sanitizedTitle}_${index + 1}.abc`;

    return {
      ...tune,
      title: fields.T || `Tune ${index + 1}`,
      filename: uniqueFilename,
      tags: abcTags,
      description: descriptionWithMetadata,
      metadata: abcMetadata,
      exists: false,
      existingAssetId: null
    };
  });
}
